module.exports = __webpack_public_path__ + "img/zhengzhou02.8fc402da.png";